import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'SearchResultsItem',
    props: {
        article: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const entries = computed(() => {
            const { publishedAt, rubrics } = props.article;
            let entries = [`${publishedAt}`];
            if (rubrics?.length) {
                entries = [...entries, ...rubrics.filter(({ to }) => !to?.startsWith('/tegi'))];
            }
            return entries;
        });
        const link = computed(() => {
            const { path = '' } = props.article;
            if (path?.startsWith('http')) {
                return {
                    component: 'a',
                    attrs: {
                        target: '_blank',
                        href: path,
                    },
                };
            }
            return {
                component: 'NLink',
                attrs: {
                    to: `/${path}`,
                },
            };
        });
        return {
            css,
            entries,
            link,
        };
    },
});
